module.exports = __webpack_public_path__ + "static/media/galleryImg19.112fcf2a.jpg";